const EXPIRY_COOKIE_NAME = "refreshTokenExpiry";

export const getRefreshTokenExpiry = () => {
  const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
  const expiryCookie = cookies.find((c) =>
    c.startsWith(`${EXPIRY_COOKIE_NAME}=`)
  );

  if (expiryCookie) {
    return parseInt(expiryCookie.split("=")[1], 10);
  }

  // If not in cookie, check in localStorage
  const localExpiry = localStorage.getItem(EXPIRY_COOKIE_NAME);
  return localExpiry ? parseInt(localExpiry, 10) : null;
};

export const isSessionExpired = () => {
  const expiry = getRefreshTokenExpiry();
  if (!expiry) return true;
  return Date.now() > expiry;
};

export const clearRefreshTokenExpiry = () => {
  document.cookie = `${EXPIRY_COOKIE_NAME}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;SameSite=lax`;
};
